import { graphql } from "./generated/index.js"

// Insert many taggings in one mutation (the reference write path's batched add).
//
// `on_conflict` ADOPTS a row that already exists unqualified — schema_key null,
// i.e. an aggregate row — into the field being written, rather than failing the
// batch: the unique constraint is on (record_id, tag_id) and does NOT include
// schema_key. A row already stamped for a DIFFERENT field is deliberately NOT
// updated (the `where` excludes it): it stays where it is, drops out of
// `returning`, and applyRelationOps' count check turns that into an error.
// Silently re-stamping it was the alternative, and that moves data the caller
// never named — out of the other field, with a success response.
export const insertManyRecordTaggings = graphql(`
  mutation insertManyRecordTaggings($objects: [record_taggings_insert_input!]!) {
    insert_record_taggings(
      objects: $objects
      on_conflict: {
        constraint: record_taggings_record_id_tag_id_unique
        update_columns: [schema_key, schema_id]
        where: { schema_key: { _is_null: true } }
      }
    ) {
      returning {
        ...RecordTaggingFields
      }
    }
  }
`)

export const deleteTaggingsByIds = graphql(`
  mutation deleteTaggingsByIds($ids: [Int!]!) {
    delete_record_taggings(where: { id: { _in: $ids } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`)
